import { VideoAssetConnection, ExclusionPeriod } from '../../utils/types';

export const getVideoUrl = (assets: VideoAssetConnection | null | undefined): string => {
	let hlsVideoUrl = '';
	if (assets?.items) {
		const hlsUrl = assets.items.find((source) => source.id === 'HLS') || assets.items.find((source) => source.format === 'HLS');
		if (hlsUrl) hlsVideoUrl = hlsUrl.url;
	}
	return hlsVideoUrl;
};

export const compareStartTime = (period1: ExclusionPeriod, period2: ExclusionPeriod): number => {
	if (period1.startTime! < period2.startTime!) {
		return -1;
	}
	if (period1.startTime! > period2.startTime!) {
		return 1;
	}
	return 0;
};
